import {
  List, Datagrid, TextField, DateField, ReferenceField,
} from 'react-admin';
import HistoryIcon from '@mui/icons-material/History';

const ActivityLogList = () => (
  <List sort={{ field: 'createdAt', order: 'DESC' }} perPage={50} hasCreate={false}>
    <Datagrid rowClick={false} bulkActionButtons={false}>
      <DateField source="createdAt" label="When" showTime />
      <ReferenceField source="userId" reference="users" link={false} emptyText="—">
        <TextField source="email" />
      </ReferenceField>
      <TextField source="action" />
      <TextField source="resourceType" label="Resource" />
      <TextField source="resourceId" label="ID" />
    </Datagrid>
  </List>
);

export default {
  list: ActivityLogList,
  icon: HistoryIcon,
  options: { label: 'Activity log' },
};
